<template>
  <div>
    <v-row>
      <v-col>
        <v-card
          class="d-flex flex-wrap justify-space-between"
        >
          <v-card
            class="pa-3"
            flat
          >
            <tw-cadastro-tag
              @update="onUpdate"
            >
              <template v-slot:activator="{ on }">
                <v-btn color="primary" class="mr-2" v-on="on">
                  <v-icon>mdi-plus</v-icon>
                  Cadastrar Tag
                </v-btn>
              </template>
            </tw-cadastro-tag>
          </v-card>
          <v-card
            class="pa-3 align-self-center"
            flat
          >
            <v-btn
              class="float-left"
              icon @click="getTags">
              <v-icon center>mdi-refresh</v-icon>
            </v-btn>
            <tw-search-text
              label="Busque por uma tag"
              v-model="searchText"
              style="max-width: 400px; width: 350px;"
              :on-search="onChangeFilter"/>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="loading">
      <tw-circular-loading/>
    </div>
    <v-data-table
      :headers="headers"
      :items="tags.content"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="tags.total"
      :footer-props="footerOptions"
      @update:options="onChangeOptions"
      no-data-text="Nenhuma tag encontrada"
      loading-text="Carregando tags..."
      :options="optionsList"
    >
      <template v-slot:item.cor="{ item }">
        <tw-tag-color :cor="item.cor"/>
      </template>
      <template v-slot:item.options="{ item }">
        <tw-cadastro-tag @update="onUpdate" :tag="item">
          <template v-slot:activator="{ on }">
            <v-btn icon small v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </tw-cadastro-tag>
        <v-btn icon small @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <tw-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import TagService from '@/api/tag-service';
import TagColor from '@/modules/tag/TagColor.vue';
import paginationMixin from '@/mixins/pagination-mixin';
import CadastroTag from './CadastroTag.vue';

export default {
  mixins: [paginationMixin],
  data: () => ({
    footerOptions: {
      itemsPerPageOptions: [5, 10, 15, 20],
      itemsPerPageText: 'Linhas por página',
    },
    headers: [
      {
        width: 10,
        text: 'Cor',
        value: 'cor',
      },
      {
        text: 'Nome',
        value: 'nome',
      },
      {
        width: 100,
        text: null,
        sortable: false,
        value: 'options',
      },
    ],
    searchText: null,
    loading: false,
    tags: {
      content: [],
      total: 0,
    },
    listOptions: {
      page: 1,
      limit: 10,
      offset: 0,
      filter: '',
      sort: 'nome',
      sortDesc: true,
    },
    optionsList: {},
  }),
  created() {
    this.getTags();
  },
  methods: {
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este tag?',
        `O tag ${item.nome} será removida e esta operação não pode ser desfeita.`,
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.onRemove(item);
        });
    },
    buildSearchFilter(filters) {
      if (!filters.searchText) {
        return '';
      }
      return `nome like "%${filters.searchText.toLowerCase()}%"`;
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getTags();
    },
    onChangeFilter() {
      this.listOptions.filter = this.buildSearchFilter({ searchText: this.searchText });
      this.resetPage();
      this.getTags();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onUpdate() {
      this.getTags();
    },
    getTags() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      TagService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then(({ data }) => {
          this.tags = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRemove(item) {
      this.loading = true;
      TagService.remove(item.id)
        .then(() => {
          this.$toast('Tag removida com sucesso', { color: 'success' });
          this.getTags();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    twCadastroTag: CadastroTag,
    twTagColor: TagColor,
  },
};
</script>
